import { Modal, Button, Form, Input } from "antd";

export default function PasswordResetModal({
  showResetPasswordModal,
  setShowResetPasswordModal,
  handleResetPassword,
  buttonLoading
}) {

  return (
    <Modal
        visible={showResetPasswordModal}
        onCancel={() => setShowResetPasswordModal(false)}
        footer={null}
        title="Reset Password"
      >
        <Form onFinish={handleResetPassword} layout="vertical">
          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[{ required: true }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Confirm New Password"
            name="confirmNewPassword"
            rules={[
              { required: true, message: "Please confirm your new password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Password mismatch"));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={buttonLoading}>
            Save
          </Button>
        </Form>
      </Modal>
  );
}